import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'
import { v4 as uuidv4 } from 'uuid'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    pillars: [],
    deletedPillars: [],
    deletedKeywords: [],
  },
  mutations: {
    setPillars(state, payload) {
      state.pillars = payload
    },
    insertPillar(state, payload) {
      const pillar = {
        pillarID: uuidv4(),
        data: {
          pillarName: payload,
        },
        keywords: [],
        change: 'create',
      }
      state.pillars.push(pillar)
      console.log(pillar)
      console.log(state.pillars)
    },
    updatePillar(state, pillar) {
      console.log('updatePillar')
      const index = state.pillars.findIndex(x => x.pillarID === pillar.pillarID)
      console.log(index)
      if (index > -1) {
        state.pillars[index] = pillar
      }
      console.log(state.pillars)
    },
    removePillar(state, payload) {
      console.log(payload)
      const index = state.pillars.indexOf(payload.pillar)
      console.log(index)
      if (index > -1) {
        state.pillars.splice(index, 1)
      }
      state.deletedPillars.push(payload.pillar)
      console.log(state.deletedPillars)
    },
    insertKeyword(state, payload) {
      delete payload.keyword.pillarID
      payload.keyword.keywordID = uuidv4()
      const pillarRef = state.pillars.indexOf(payload.pillar)
      state.pillars[pillarRef].keywords.push(payload.keyword)
      state.pillars[pillarRef].keywordChange = true
    },
    updateKeyword(state, payload) {
      const pillarRef = state.pillars.indexOf(payload.pillar)
      const keywordRef = state.pillars[pillarRef].keywords.indexOf(payload.keyword)
      const conceptRef = payload.keyword.data.concepts.indexOf(payload.concept)
      if (payload.type === 'insert') {
        payload.pillar.keywordChange = true
        payload.pillar.keywords[keywordRef].data.concepts.push(payload.concept)
        Vue.set(state.pillars, pillarRef, payload.pillar)
      } else if (conceptRef > -1) {
        payload.pillar.keywords[keywordRef].data.concepts.splice(conceptRef, 1)
        payload.pillar.keywordChange = true
        Vue.set(state.pillars, pillarRef, payload.pillar)
      }
    },
    removeKeyword(state, payload) {
      const pillarRef = state.pillars.indexOf(payload.pillar)
      const keywordRef = state.pillars[pillarRef].keywords.indexOf(payload.keyword)
      if (keywordRef > -1) {
        payload.pillar.keywords.splice(keywordRef, 1)
        payload.keyword.pillarID = payload.pillar.pillarID
        state.deletedKeywords.push(payload.keyword)
        Vue.set(state.pillars, pillarRef, payload.pillar)
      }
    },
  },
  actions: {
    getPillars(context) {
      const payload = []
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              pillarID: doc.id,
              data: doc.data(),
            }
            payload.push(data)
          })
          context.dispatch('connectKeywords', payload)
        })
    },
    connectKeywords(context, pillars) {
      pillars.forEach(pillar => {
        context.dispatch('getKeywords', pillar)
      })
      context.commit('setPillars', pillars)
    },
    getKeywords(context, pillar) {
      const keywords = []
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .doc(pillar.pillarID)
        .collection('keywords')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              keywordID: doc.id,
              data: doc.data(),
            }
            keywords.push(data)
          })
          pillar.keywords = keywords
          return pillar
        })
    },
    // updatePillar(context, pillar) {
    //   console.log('updatePillar >> ', pillar.data.pillarName)
    //   const data = pillar.data
    //   firebaseDatabase.collection('creators')
    //     .doc(firebaseAuth.currentUser.uid)
    //     .collection('pillars')
    //     .doc(pillar.pillarID)
    //     .update({
    //       active: data.active,
    //       pillarDescription: data.pillarDescription,
    //       pillarName: data.pillarName,
    //     })
    // },
    // createPillar(context, pillarName) {
    //   console.log('createPillar')
    //   firebaseDatabase.collection('creators')
    //     .doc(firebaseAuth.currentUser.uid)
    //     .collection('pillars')
    //     .add({
    //       pillarName: pillarName,
    //     })
    //     .then(res => console.log(res.id))
    // },
  },
  getters: {
    state: state => state,
  },
}
